import { useEffect } from 'react'

import { shallowEqual } from 'react-redux'

import { useIntercom } from 'react-use-intercom'

import { useGetAccountQuery } from 'store/account/accountApiWithQuery'

import {
  useGetEntitlementsQuery,
  useGetSessionsQuery,
} from 'store/company/companyApiWithQuery'

import { State } from 'store/state'

import { useAppSelector } from '../store/hooks'

import { identifyIntercomUser } from './identifyIntercomUser'
import { useAuthRoles } from './useAuthRoles'

export const useCompany = () => {
  const { isAdmin } = useAuthRoles()

  const { user, jwt, intercom, company, companyId, accountId, charlieUser } =
    useAppSelector(
      (state: State) => ({
        user: state.authReducer.user,
        charlieUser: state.authReducer.charlieUser,
        jwt: state.authReducer.jwt,
        intercom: state.authReducer.intercom,
        company: state.companyReducer.company,
        companyId: state.apiHeadersReducer.companyId,
        accountId: state.apiHeadersReducer.accountId,
      }),
      shallowEqual
    )

  const { data: account, refetch: refetchAccount } = useGetAccountQuery()

  const { refetch: refetchSessions } = useGetSessionsQuery()

  const { update: updateIntercom, shutdown: shutdownIntercom } = useIntercom()

  useGetEntitlementsQuery(undefined, { skip: !jwt || !companyId })

  useEffect(() => {
    if (account && jwt) {
      if (charlieUser && intercom?.intercomUserHash && intercom?.intercomId) {
        identifyIntercomUser({
          userHash: intercom.intercomUserHash,
          intercomId: intercom.intercomId,
          charlieCompanyId: charlieUser?.companyId,
          charlieCompanyName: charlieUser?.companyName,
          updateIntercom,
          shutdownIntercom,
          isAdmin,
        })
      }

      refetchSessions()
    }
  }, [
    updateIntercom,
    shutdownIntercom,
    user,
    isAdmin,
    refetchSessions,
    intercom?.intercomUserHash,
    intercom?.intercomId,
    charlieUser,
    account,
    jwt,
  ])

  useEffect(() => {
    if (companyId && accountId && !company) {
      refetchAccount()
    }
  }, [companyId, accountId, company, refetchAccount])
}
